// JavaScript doesn't have a built-in modulo function, the '%' operator is
// actually the remainder function in JavaScript.
// Modulo and remainder are the same for positive values, but for negative values
// they give different results.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
export function modulo(first: number, second: number): number {
  return ((first % second) + second) % second;
}
